<template>

  <vx-card class="grid-view-item mb-base overflow-hidden mb-5">
    <div slot="no-body">
      <img :src="classRoomPictureCompute"
           alt="content-img"
           class="responsive card-img-top cursor-pointer">
    </div>

    <div class="vx-row align-items-center mb-5">
      <div class="vx-col w-1/5 border-r-2 text-center"
           style="border-right: 1px solid #d8d6de;">
        <h6 class="mb-0">{{ onAirDateStringShort }}</h6>
        <h3 class="mb-0">{{ onAirDateShort }}</h3>
      </div>
      <div class="vx-col w-4/5 my-auto">
        <h4 class="card-title mb-25">{{item.topicLocal}}</h4>
        <p class="card-text mb-0" v-line-clamp="1">{{ item.descriptionLocal }}</p>
      </div>
    </div>

    <div class="flex align-items-start mb-5">
      <div class="flex mr-1 align-self-start">
        <vs-chip color="primary"
                  transparent>
          <feather-icon icon="CalendarIcon"
                        svgClasses="h-6 w-6 stroke-current text-primary my-1"
                        class="block" />
        </vs-chip>
      </div>
      <div class="flex justify-between w-full">
        <div>
          <h6 class="mb-0">{{onAirDate}}</h6>
          <small>{{ onAirTime }}</small>
        </div>

        <vs-chip v-if="isOnAir" color="danger"
                 transparent>
          {{ $t('teacher-dash-board.now-on-air') }}
        </vs-chip>

      </div>
    </div>

    <div class="flex align-items-start mb-5">
      <div class="flex mr-1 align-self-start">
        <vs-chip color="primary"
                 transparent>
          <feather-icon icon="BookIcon"
                        svgClasses="h-6 w-6 stroke-current text-primary my-1"
                        class="block" />
        </vs-chip>
      </div>
      <div class="w-full">

        <div class="flex justify-between center">
          <div class="flex justify-center">
            <h6 class="mb-0">{{ item.subject.code }}</h6>
          </div>

          <div class="flex justify-center">
            <p class="mb-0">
              {{$t('class-over-view.section-short')}} {{ item.classSection.sectionNo }}
              {{$t('class-over-view.learn-span-no-short')}} {{ item.classSection.learnSpanNo }}
            </p>
          </div>
        </div>
        <small v-line-clamp="1">{{ item.subject.nameLocal }}</small>
      </div>
    </div>

<!--    <div class="flex justify-between flex-wrap center">
      <h5 class="mb-2 hover:text-primary cursor-pointer">
        {{ item.subject.code }}
      </h5>

      <vs-chip v-if="isOnAir" color="danger"
               transparent>
        {{ $t('teacher-dash-board.now-on-air') }}
      </vs-chip>

      <vs-chip color="primary" transparent>
        {{ studentRegisterQty }}/{{ studentQty }}
      </vs-chip>
    </div>

    <p class="text-grey">{{ item.subject.nameLocal }}</p>

    <div class="flex justify-between flex-wrap mt-2">
      <span class="flex items-center">
        {{ onAirDate }}
      </span>

      <span class="flex items-center mr-2">
          <feather-icon class="mr-2" icon="ClockIcon" svgClasses="text-dark stroke-current h-6 w-6"/>
          {{ onAirTime }}
      </span>
    </div>

    <vs-divider/>-->


<!--    <span class="text-grey">{{ $t('live-class-schedule.topic') }}: </span>
    <span class="text-secondary">{{ item.topicLocal }}</span>
    <br>
    <span class="text-grey">{{ $t('live-class-schedule.live-from') }}: </span>
    <span class="text-secondary">{{ item.descriptionLocal }}</span>
    <br>-->

    <!--    EXTERNAL LIVE-->
    <div class="flex justify-between flex-wrap center" v-if="item.externalLink && canClickLink">
      <div class="flex justify-center mt-2 mb-0">
        <vs-button color="success"
                   icon="icon-link"
                   icon-pack="feather" size="small"
                   @click="goToExternalLink(item.externalLink)">
          {{ $t('advisor-online-schedule.go-to-external-link') }}
        </vs-button>
      </div>
      <div class="flex justify-center mt-2 mb-0">
        <vs-button v-clipboard:copy="item.externalPassword"
                   v-clipboard:success="onCopy" icon="icon-copy"
                   icon-pack="feather"
                   size="small">
          {{ $t('live-class-schedule.copy-password') }}
        </vs-button>
      </div>
    </div>

    <!--    REPORT-->
    <div class="flex justify-center flex-wrap center mt-2" v-if="item.yeaLinkImportDataQty > 0">
      <vs-button color="primary"
                 icon="icon-download"
                 icon-pack="feather"
                 @click="handlerAdvisorOnlineRecordClick(item.id)">
        {{ $t('home.advisor-online-record') }}
      </vs-button>
    </div>

    <!--SLOT: ACTION BUTTONS -->
    <slot name="action-buttons"/>

  </vx-card>

</template>

<script>
import moment from 'moment';
import {dateTimeFormat} from '@/utils/format';
import {config, getClassRoomUrl} from "@/utils/upload";
import {showLocalNotification, notificationType} from "@/utils/notification";
import {APIServerPrisma2} from "@/constants/config";


export default {
  props: [
    'item',
    'index',
  ],
  data() {
    return {
      classRoomPicture: this.getClassRoomPicture(this.item),
    }
  },
  computed: {
    studentRegisterQty() {
      if (this.item.classSection) {
        return this.item.classSection.studentRegisterQty;
      }
      return 0
    },
    studentQty() {
      if (this.item.classSection && this.item.classSection.classRoom) {
        return this.item.classSection.classRoom.capacity;
      }
      return 0
    },
    classRoomPictureCompute() {
      return this.classRoomPicture;
    },
    onAirDateStringShort(){
      if (this.item) {
        let dateFrom = this.item.dateTimeFrom;

        return moment(dateFrom).locale(this.$i18n.locale).format('ddd').toUpperCase();
      } else {
        return '-';
      }
    },
    onAirDateShort(){
      if (this.item) {
        let dateFrom = this.item.dateTimeFrom;

        return moment(dateFrom).format('DD');
      } else {
        return '-';
      }
    },
    onAirDate() {
      if (this.item) {
        let dateFrom = this.item.dateTimeFrom;

        return moment(dateFrom).locale(this.$i18n.locale).format('ddd, MMM DD, YYYY');
      } else {
        return '-';
      }
    },
    onAirTime() {
      if (this.item) {
        let dateFrom = this.item.dateTimeFrom;
        let dateTo = this.item.dateTimeTo;

        return moment(dateFrom).format(dateTimeFormat.momenthhmm + ' A')
          + ' - ' + moment(dateTo).format(dateTimeFormat.momenthhmm + ' A');
      } else {
        return '-';
      }
    },
    isOnAir() {
      let dateFrom = moment(this.item.dateTimeFrom);
      let dateTo = moment(this.item.dateTimeTo);

      return moment(new Date()).isBetween(dateFrom, dateTo);
    },
    streamKey() {
      return this.item.rtmpServer + this.item.rtmpStream;
    },
    canClickLink(){
      let dateTimeTo = moment(this.item.dateTimeTo);

      return moment(new Date()).isSameOrBefore(dateTimeTo);
    },
  },
  methods: {
    //---------------------------------------- Event Function ------------------------------------------------------//
    onCopy() {
      showLocalNotification(this.$vs
        , this.$t('general.success'),
        this.$t('teacher-dash-board.copy-success')
        , notificationType.SUCCESS);
    },
    goToExternalLink(link) {
      window.open(link, '_blank');
    },
    //---------------------------------------- Local Function ------------------------------------------------------//
    getClassRoomPicture(item) {
      if (item.courseOutlineRegistration.courseOutline.picturePath) {
        return getClassRoomUrl(item.courseOutlineRegistration.courseOutline.picturePath);
      } else {
        let indexStr = String(this.index);
        let classRoomPlaceholderIndex = String(indexStr).substr(indexStr.length - 1, indexStr.length);
        return config.baseUrl + 'static/images/classroom-placeholder-' + classRoomPlaceholderIndex + '.jpeg';
      }
    },
    handlerAdvisorOnlineRecordClick(advisorOnlineScheduleId){
      const rsc = JSON.parse(localStorage.getItem("rsc"));
      let entity, stage
      if (rsc) {
        entity = rsc.e_code;
        stage = rsc.r_stage;
      }
      let url = APIServerPrisma2
        + '/api/export_excel_advisor_online_record'
        + '/' + advisorOnlineScheduleId
        + '/' + entity
        + '/' + stage;
      window.open(url, '_self');
    },
  }
}
</script>

<style lang="scss" scoped>
.grid-view-item {
  .grid-view-img {
    max-width: 100%;
    max-height: 100%;
    width: auto;
    transition: .35s;
  }

  &:hover {
    transform: translateY(-5px);
    box-shadow: 0px 4px 25px 0px rgba(0, 0, 0, .25);

    .grid-view-img {
      opacity: 0.9;
    }
  }
}
</style>
